import axios from '@axios'

const get = (url, commit, commitKey, responseKey = null, queryParams = {}) => new Promise((resolve, reject) => {
  axios.get(url, { params: queryParams })
    .then(response => {
      commit(commitKey, responseKey ? response.data[responseKey] : response.data)
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})
export default {
  dcType({ commit }) {
    return get('/static/dc_type', commit, 'SET_DC_TYPES', 'dc_type')
  },
  role({ commit }) {
    return get('/static/role', commit, 'SET_ROLES', 'roles')
  },
  scientificDegree({ commit }) {
    return get('/static/scientific_degree', commit, 'SET_SCIENTIFIC_DEGREES', 'scientific_degree')
  },
  scientificTitle({ commit }) {
    return get('/static/scientific_title', commit, 'SET_SCIENTIFIC_TITLES', 'scientific_title')
  },
  orgType({ commit }) {
    return get('/static/type_org', commit, 'SET_ORG_TYPES', 'type_org')
  },
  eduLangTypes({ commit }) {
    return get('/static/dc_edu_type', commit, 'EDU_LANG_TYPES', 'edu_lang_type')
  },
  periodTypes({ commit }) {
    return get('/static/period_types', commit, 'SET_PERIOD_TYPES', 'period_types')
  },
  scientificWorkTypes({ commit }) {
    return get('/static/dc_scientific_work_type', commit, 'SET_SCIENTIFIC_WORK_TYPES', 'scientific_work_type')
  },
  letterStatuses({ commit }) {
    return get('/static/dc_letter_status', commit, 'SET_LETTER_STATUSES', 'letter_status')
  },
  applyDocumentStatuses({ commit }) {
    return get('/static/dc_apply_doc_status', commit, 'SET_APPLY_DOCUMENT_STATUSES', 'apply_doc_status')
  },
  letterTypes({ commit }) {
    return get('/static/dc_letter_type', commit, 'SET_LETTER_TYPES', 'letter_type')
  },
  organization({ commit }) {
    return get('/static/dc_letter_type', commit, 'SET_LETTER_TYPES', 'letter_type')
  },
  activeQuarter({ commit }) {
    return get('/quarter/active_quarter/', commit, 'SET_ACTIVE_QUARTER')
  },
  quoteOrgTypes({ commit }) {
    return get('/static/get_quote_org_type/', commit, 'SET_QUOTE_ORG_TYPES')
  },
  totalQuoteTypes({ commit }) {
    return get('/static/get_total_quote_type', commit, 'SET_TOTAL_QUOTE_TYPES')
  },
  quarters({ commit }) {
    return get('/quarter/', commit, 'SET_QUOTES', 'results', { limit: 1000 })
  },
  directionList({ commit }, queryParams = {}) {
    return get('/org-directions/direction_list/', commit, 'SET_DIRECTION_LIST', null, queryParams)
  },
  categorySubjectList({ commit }, queryParams = {}) {
    return get('/category-subjects', commit, 'SET_CATEGORY_SUBJECT_LIST', null, queryParams)
  },
  universityList({ commit }, queryParams = {}) {
    return get('/organizations/university_list/', commit, 'SET_UNIVERSITY_LIST', null, queryParams)
  },
  periodList({ commit }, queryParams = { monitoring: true, limit: 100 }) {
    return get('/periods/', commit, 'SET_PERIOD_LIST', 'results', queryParams)
  },
  admissionYearPeriodList({ commit }) {
    return get('/monitoring-report/admission_year/', commit, 'SET_ADMISSION_YEAR_PERIOD_LIST')
  },
  regions({ commit }, queryParams = { limit: 9999 }) {
    return get('/regions/', commit, 'SET_REGION_LIST', 'results', queryParams)
  },
  certificates({ commit }, queryParams = { limit: 9999, status: 100 }) {
    return get('/certificate-langs/', commit, 'SET_CERTIFICATE_LIST', 'results', queryParams)
  },
  certificateTypes({ commit }, queryParams = { limit: 9999, status: 100 }) {
    return get('/certificate-types/', commit, 'SET_CERTIFICATE_TYPES', 'results', queryParams)
  },
  organizationList({ commit }, queryParams = { monitoring: true }) {
    return get('/organizations/org_list_name_id/', commit, 'SET_ORGANIZATION_LIST', null, queryParams)
  },
  scientificTopicDirection({ commit }) {
    return get('/scientific-topic-direction/', commit, 'SET_SCIENTIFIC_TOPIC_DIRECTIONS', 'results')
  },
  supervisorList(store, queryParams = {}) {
    return axios.get('/statistics/supervisor_list', { params: queryParams })
  },
  otmItmApplyDocsExel(store, queryParams = {}) {
    return axios.get('/statistics/otm_itm_apply_docs_exel', { params: queryParams })
  },
  checkMonitoringListQueue(store, queryParams = {}) {
    return axios.get('/statistics/check_monitoring_list_queue', { params: queryParams })
  },
  monitoringReportListQueue(store, queryParams = {}) {
    return axios.get('/statistics/monitoring_report_list_queue', { params: queryParams })
  },
  researchAdvisors({ commit }, queryParams = {}) {
    return new Promise((resolve, reject) => {
      axios.get('/research-advisor/', { params: queryParams }).then(({ data }) => {
        const used = new Set()
        const users = []
        // eslint-disable-next-line no-restricted-syntax
        for (const result of data.results) {
          const { user } = result
          if (!used.has(user.id)) {
            users.push(user)
            used.add(user.id)
          }
        }

        commit('SET_RESEARCH_ADVISORS', [...users])
        resolve(users)
      }).catch(error => reject(error))
    })
  },
  applyDocsList(store, queryParams = {}) {
    return axios.get('/statistics/apply_docs_list_queue', { params: queryParams })
  },
  checkTaskStatus(store, taskId) {
    return axios.get('/statistics/check_task_status', { params: { task_id: taskId } })
  },
  oakStatus() {
    return axios.get('/oak/get-status')
  },
  scientificInformation() {
    return axios.get('/auth/user/science-id-data')
  },
  sendSmsCode() {
    return axios.post('/send_sms_code/')
  },
  download(_, url) {
    return new Promise((resolve, reject) => {
      axios({
        url,
        method: 'GET',
        responseType: 'blob',
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
